import { Mixpanel } from '../../../../utils/mixpanel';
import { AICA_CASHFLOW_BANKING, AICA_CASHFLOW_BANKING_FILTER_CHANGED } from '../../../../utils/constants/mixpanelEvents/investorEvents';
import { CASHFLOW_FROM_BANKING } from '../Financials/constants';
import { CFB_FILTER_TYPES, CFB_OPENED_SOURCES } from './constants';
import { CfbFilterLocation, CfbOpenedSource, CfbFilterTrackingArgs, CfbFilterType } from './types';

function trackFilterChanged(
    filterType: CfbFilterType,
    value: string,
    previousValue: string | null | undefined,
    location: CfbFilterLocation,
) {
    if (value === previousValue) return;
    Mixpanel.track(AICA_CASHFLOW_BANKING_FILTER_CHANGED, { filterType, value, location });
}

let cfbOpenedThisPageLoad = false;
let linkLandingPending = false;

export function resetCfbLandingState() {
    cfbOpenedThisPageLoad = false;
    linkLandingPending = false;
}

export function markCfbLinkLanding() {
    linkLandingPending = true;
}

export function resolveCfbLandingSource(): CfbOpenedSource {
    const source = linkLandingPending || !cfbOpenedThisPageLoad ? CFB_OPENED_SOURCES.LINK : CFB_OPENED_SOURCES.REVISIT;
    linkLandingPending = false;
    return source;
}

export function trackCfbOpened(source: CfbOpenedSource) {
    cfbOpenedThisPageLoad = true;
    Mixpanel.track(AICA_CASHFLOW_BANKING, { source });
}

export function trackBankingTypeSwitch(nextType: string, currentType: string) {
    const opensCfb = nextType === CASHFLOW_FROM_BANKING && currentType !== CASHFLOW_FROM_BANKING;
    if (opensCfb) trackCfbOpened(CFB_OPENED_SOURCES.PILL);
    return opensCfb;
}

export function createCfbFilterTracking(
    location: CfbFilterLocation,
    { quickRangeHandlers, activeQuickRange, startMonth, endMonth, unit, selectStartMonth, selectEndMonth, setUnit }: CfbFilterTrackingArgs,
) {
    return {
        selectQuickRange: (rangeId: string) => {
            trackFilterChanged(CFB_FILTER_TYPES.QUICK_RANGE, rangeId, activeQuickRange, location);
            quickRangeHandlers[rangeId]?.();
        },
        selectStartMonth: (month: string) => {
            trackFilterChanged(CFB_FILTER_TYPES.CUSTOM_START_DATE, month, startMonth, location);
            selectStartMonth(month);
        },
        selectEndMonth: (month: string) => {
            trackFilterChanged(CFB_FILTER_TYPES.CUSTOM_END_DATE, month, endMonth, location);
            selectEndMonth(month);
        },
        changeUnit: (nextUnit: string) => {
            trackFilterChanged(CFB_FILTER_TYPES.UNIT, nextUnit, unit, location);
            setUnit?.(nextUnit);
        },
    };
}
